<div>
   <div class="mt-2 ml-2 col-12">
        <app-ef-setup-inputs
            [activeIngredients]="activeIngredients" 
            [geographies]="geographies"
            [currentUserName]="currentUserName"
            (onActiveIngredientSelectionChangeEvent)="onActiveIngredientSelectionChanged($event)"
            (onQueryFilterChangeEvent)="onActiveIngredientFilterChanged($event)"
            (onGeographySelectionChangeEvent)="onGeographySelectionChanged($event)"
            (isSetupValidEvent)="onSetupValidChanged($event)"
            ></app-ef-setup-inputs>
    </div>
    <div class="mt-5 ml-2 col-12 md:col-8 lg:col-6">
        <app-ef-setup-models-to-be-run [modelsLoading]="modelsLoading"
            [modelsToBeRun]="modelsToBeRun" [columnsDefinition]="columnDef"
            [modelsCollection]="modelsCollection"
            (orderedModelsToBeRunRowData)="orderedModelsToBeRunRowData()"
            (selectedMoleculesChanged)="onSelectedMoleculesChanged($event)"></app-ef-setup-models-to-be-run>
    </div>
</div>

